export const STAGED_CHANGES_LABELS = {
  LOADING: 'Loading the staged changes…',
  EMPTY: 'No changes are staged, so this commit will not change the loan.',
  HEADING: ({ count }) =>
    count === 1
      ? 'This will commit 1 staged change to the loan:'
      : `This will commit ${count} staged changes to the loan:`,
};

export const StagedChangesTestIds = {
  LOADING: 'AiActivity_StepStagedChanges_Loading',
  EMPTY: 'AiActivity_StepStagedChanges_Empty',
  LIST: 'AiActivity_StepStagedChanges_List',
  HEADING: 'AiActivity_StepStagedChanges_Heading',
};
